/* eslint-disable eqeqeq */
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import FormBox from "../../components/FormBox/FormBox";
import CustomBreadCrumbs from "../../components/CustomBreadCrumbs";
import MultipleFormBoxComp from "../../components/FormBox/MultipleFormBoxComp";
import { brokerForm5 } from "./brokerFormConst";
import { Container, Row, Col, Form, Button, Table } from "react-bootstrap";
const LoanApplication = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      loanInformation_LateFeeDistributionSLS: 50,
      loanInformation_ServicingFeePerLenderPerMonth: 20.0,
      loanInformation_FileSetupFee: 30.0,
    },
  });
  const [submitLoading, setSubmitLoading] = useState(false);
  const onSubmit = (data) => {
    setSubmitLoading(true);
    const id = toast.loading("Loan Submission Pending");

    try {
      // const headers = {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      // };
      // await axios.post(
      //   urls.submitaLoan.postSubmitaLoan(),
      //   {
      //     user_id: localStorage.getItem("apex_userid"),
      //     loan_submission_details: data,
      //   },
      //   headers
      // );
      toast.update(id, {
        render: "Loan Submitted Succesfuly",
        type: "success",
        isLoading: false,
        ...commonToast,
      });
      setSubmitLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <CustomBreadCrumbs
          crumbs={[
            { title: "Broker Forms", link: "/broker/forms" },
            { title: "1003 Loan Application Form" },
          ]}
        />
        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <form>
              <div className="loans-in-details mt-5">
                {brokerForm5?.map((data, index) => {
                  return (
                    <MultipleFormBoxComp
                      key={index}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      options={data.arr}
                      errors={errors}
                    />
                  );
                })}
                <button
                  onClick={handleSubmit(onSubmit)}
                  className="btn btn-primary text-white"
                >
                  Submit
                </button>
              </div>
            </form>
          </section>
        </article>
      </section>
    </div>
  );
};
export default LoanApplication;

export const LoanForm = () => {
  // Structure for initial state reflecting questions and responses
  const initialState = {
    1: { borrower: "no", coBorrower: "no" },
    2: { borrower: "no", coBorrower: "no" },
    3: { borrower: "no", coBorrower: "no" },
    4: { borrower: "no", coBorrower: "no" },
    5: { borrower: "no", coBorrower: "no" },
    6: { borrower: "no", coBorrower: "no" },
    7: { borrower: "no", coBorrower: "no" },
    8: { borrower: "no", coBorrower: "no" },
    9: { borrower: "no", coBorrower: "no" },
    10: { borrower: "no", coBorrower: "no" },
    11: { borrower: "no", coBorrower: "no" },
    12: { borrower: "no", coBorrower: "no" },
    13: { borrower: "no", coBorrower: "no" },
  };

  const [responses, setResponses] = useState(initialState);

  const handleChange = (question, role, value) => {
    setResponses((prevResponses) => ({
      ...prevResponses,
      [question]: {
        ...prevResponses[question],
        [role]: value,
      },
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle the form submission
  };

  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <Table bordered responsive>
          <thead>
            <tr>
              <th>Questions</th>
              <th>Borrower</th>
              <th>Co-Borrower</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(initialState).map((question, index) => (
              <tr key={question}>
                <td>
                  {" "}
                  {index === 0 &&
                    "a. Are there any outstanding judgments against you?"}
                  {index === 1 &&
                    "b. Have you been declared bankrupt within the past 7 years?"}
                  {index === 2 &&
                    "c. Have you had property foreclosed upon or given title or deed in lieu thereof in the last 7 years?"}
                  {index === 3 && "d. Are you a party to a lawsuit?"}
                  {index === 4 &&
                    "e. Have you directly or indirectly been obligated on any loan which resulted in foreclosure, transfer of title in lieu of foreclosure, or judgment?"}
                  {index === 5 &&
                    "f. Are you presently delinquent on or in default on any Federal debt or any other loan, mortgage, financial obligation, bond, or loan guarantee?"}
                  {index === 6 &&
                    "g. Are you obligated to pay alimony, child support, or separate maintenance?"}
                  {index === 7 &&
                    "h. Is any part of the down payment borrowed?"}
                  {index === 8 &&
                    "i. Are you a co-maker or endorser on a note?"}
                  {index === 9 && "j. Are you a U.S. citizen?"}
                  {index === 10 && "k. Are you a permanent resident alien?"}
                  {index === 11 &&
                    "l. Do you intend to occupy the property as your primary residence?"}
                  {index === 12 &&
                    "m. Have you had an ownership interest in a property in the last three years?"}
                </td>

                {["borrower", "coBorrower"].map((role) => (
                  <td key={role}>
                    <Form.Check
                      inline
                      label="Yes"
                      type="checkbox"
                      checked={responses[question][role] === "yes"}
                      onChange={() => handleChange(question, role, "yes")}
                    />
                    <Form.Check
                      inline
                      label="No"
                      type="checkbox"
                      name={question + role}
                      checked={responses[question][role] === "no"}
                      onChange={() => handleChange(question, role, "no")}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </Form>
    </Container>
  );
};
